// export const StrToTwoDecimal = (value: string): number => {
//   const numericValue = value.replace(/[^\d.-]/g, '');
//   if (numericValue === '') return 0;
//   return parseFloat(parseFloat(numericValue).toFixed(2));
// };
export const StrToTwoDecimal = (value: string | number): number => {
  const str = typeof value === 'number' ? value.toString() : value;
  const numericValue = str.replace(/[^\d.-]/g, '');
  if (numericValue === '') return 0;
  return parseFloat(parseFloat(numericValue).toFixed(2));
};

export const formatNumberWithCommas = (
  value: number | string,
  digits = 2
): string => {
  const number = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(number)) return '0.00';
  return number.toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};
